module.exports = __webpack_public_path__ + "img/CV.534d28fb.jpg";